export * from "-!../../../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./ads-banner.vue?vue&type=template&id=8c035f94&"


//////////////////
// WEBPACK FOOTER
// ./src/templates/pages/events/components/ads-banner/ads-banner.vue?vue&type=template&id=8c035f94&
// module id = 1059
// module chunks = 0